<template>
  <div>
    <a-layout>
      <a-layout-sider :width="200" breakpoint="md" collapsible theme="light">
        <a-spin :spinning="loadingParent">
          <a-menu mode="inline" style="min-height: 70px;" @select="seleccionarMenu">
            <a-menu-item key="DATOSPERSONALES" v-if="roles.permiso_bloque_1 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="idcard"/>
              <span>{{$t('Identificación')}} </span>
            </a-menu-item>
            <a-menu-item key="CLIENTE" v-if="roles.permiso_bloque_13 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="user"/>
              <span>{{$t('Cliente')}} </span>
            </a-menu-item>
            <a-menu-item key="CARGUEDOCUMENTACION" v-if="roles.permiso_bloque_3 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="cloud-upload"/>
              <span>{{$t('Carpeta')}}</span>
            </a-menu-item>
            <a-menu-item key="DATOSFAMILIARES" v-if="roles.permiso_bloque_4 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="team"/>
              <span>{{$t('Familia')}} </span>
            </a-menu-item>
            <a-menu-item key="OTROSDATOSFAMILIARES" v-if="roles.permiso_bloque_5 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="warning"/>
              <span>{{$t('Emergencia')}} </span>
            </a-menu-item>
            <a-menu-item key="INFORMACIONACADEMICA" v-if="roles.permiso_bloque_6 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="read"/>
              <span>{{$t('Academia')}} </span>
            </a-menu-item>
            <a-menu-item key="IDIOMAOTROSESTUDIOS" v-if="roles.permiso_bloque_8 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="book"/>
              <span>{{$t('Formación')}} </span>
            </a-menu-item>
            <a-menu-item key="REFERENCIAS" v-if="roles.permiso_bloque_7 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="contacts"/>
              <span>{{$t('Referencias')}} </span>
            </a-menu-item>
            <a-menu-item key="INFORMACIONLABORAL" v-if="roles.permiso_bloque_11 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="audit"/>
              <span>{{$t('Experiencia')}} </span>
            </a-menu-item>
            <a-menu-item key="INFORMACIONBANCARIA" v-if="roles.permiso_bloque_10 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="wallet"/>
              <span>{{$t('Banco')}} </span>
            </a-menu-item>
            <a-menu-item key="OTROSDATOSPERSONALES" v-if="roles.permiso_bloque_2 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="car"/>
              <span>{{$t('Conducción')}}</span>
            </a-menu-item>
            <a-menu-item key="OTRAINFORMACIONLABORAL" v-if="roles.permiso_bloque_9 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="reconciliation"/>
              <span>{{$t('Adicionales')}} </span>
            </a-menu-item>
            <a-menu-item key="FORMULARIOS" v-if="roles.permiso_bloque_12 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="profile"/>
              <span>{{$t('Formularios')}} </span>
            </a-menu-item>
            <a-menu-item key="FINALIZACIONINGRESODATOS" v-if="roles.permiso_bloque_14 &&
                                                              !$isEmpty(personaSeleccioanda) &&
                                                              $getConfigValue('BIODATA_VER_OPCION_FINALIZAR_INGRESO_DATOS', 'NO') === 'SI'">
              <a-icon type="history"/>
              <span>{{$t('Finalizar')}} </span>
            </a-menu-item>
          </a-menu>
        </a-spin>
      </a-layout-sider>
      <a-layout-content>
<!--        <a-row :gutter="[16,16]" style="margin: 5px">-->
<!--          <a-col v-if="menuActivo != menu.datosPersonales" :md="24" :xs="24">-->
<!--            <a-spin :spinning="loading">-->
<!--              <biodata-resumen :tamanoimg="100" :persona="persona">-->
<!--              </biodata-resumen>-->
<!--            </a-spin>-->
<!--          </a-col>-->
<!--        </a-row>-->
        <a-row :gutter="[16,16]" style="margin: 5px" id="test">
          <a-col :md="puedeCrear?12:24" :xs="24">
            <a-spin :spinning="loading">
              <biodata-resumen :tamanoimg="81" :persona="persona">
              </biodata-resumen>
            </a-spin>
          </a-col>
          <a-col :span="24" :md="12" :xs="24" v-if="puedeCrear">
            <a-spin :spinning="loading">
              <a-form :form="form">
                <a-card>
                  <a-form :form="form">
                    <a-row :gutter="[12,12]">
                      <g-lookup :label="$t('Buscar Persona')"
                                :formItemConfig="{
                            'label-col': {},
                            'wrapper-col': {},
                            'has-feedback': false
                          }"
                                endpoint="personas"
                                ref="persona"
                                :decorator="['identificacion']"
                                @change="personaCambiada">
                      </g-lookup>
                      <biodata-crear-persona @success="personaCreada"></biodata-crear-persona>
                    </a-row>
                  </a-form>
                </a-card>
              </a-form>
            </a-spin>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.datosPersonales && roles.permiso_bloque_1">
            <biodata-datos-personales :persona="personaSeleccioanda"></biodata-datos-personales>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.otrosdatosPersonales && roles.permiso_bloque_2">
            <biodata-conduccion :persona="personaSeleccioanda"></biodata-conduccion>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.carguedocumentacion && roles.permiso_bloque_3">
            <biodata-cargue-documentacion :persona="personaSeleccioanda"></biodata-cargue-documentacion>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.datosfamiliares && roles.permiso_bloque_4">
            <biodata-datos-familiares :persona="personaSeleccioanda"></biodata-datos-familiares>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.otrosdatosfamiliares && roles.permiso_bloque_5">
            <biodata-otros-datos-familiares :persona="personaSeleccioanda"></biodata-otros-datos-familiares>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.informacionacademica && roles.permiso_bloque_6">
            <biodata-informacion-academica :persona="personaSeleccioanda"></biodata-informacion-academica>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.referencias && roles.permiso_bloque_7">
            <biodata-referencias :persona="personaSeleccioanda"></biodata-referencias>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.idiomaotrosestudios && roles.permiso_bloque_8">
            <biodata-idioma-otros-estudios :persona="personaSeleccioanda"></biodata-idioma-otros-estudios>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.otrainformacionlaboral && roles.permiso_bloque_9">
            <biodata-otra-informacion-laboral
              :persona="personaSeleccioanda"></biodata-otra-informacion-laboral>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.informacionbancaria && roles.permiso_bloque_10">
            <biodata-informacion-bancaria :persona="personaSeleccioanda"></biodata-informacion-bancaria>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.informacionlaboral && roles.permiso_bloque_11">
            <biodata-informacion-laboral :persona="personaSeleccioanda"></biodata-informacion-laboral>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.forularios && roles.permiso_bloque_12">
            <biodata-otros-formularios :persona="personaSeleccioanda"></biodata-otros-formularios>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.cliente && roles.permiso_bloque_13">
            <biodata-cliente :persona="personaSeleccioanda"></biodata-cliente>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.finalizacioningresodatos &&
                                  roles.permiso_bloque_14 &&
                                  $getConfigValue('BIODATA_VER_OPCION_FINALIZAR_INGRESO_DATOS', 'NO') === 'SI'">
            <biodata-finalizar-ingreso-datos :persona="personaSeleccioanda"></biodata-finalizar-ingreso-datos>
          </a-col>
        </a-row>
      </a-layout-content>
    </a-layout>


    <a-modal :visible="isPoliticsVisible"
             title="Políticas de la empresa"
             :cancel-button-props="{props: { disabled: true } }"
             :ok-button-props="{props: { disabled: politicState } }"
             :closable="false"
             :maskClosable="false"
             @ok="changeStatePolitics"
    >
      <a-spin :spinning="loadingPolitics">
        <a-row :gutter="[16,16]">
          <a-col>
            <div v-html="$getConfigValue('POLITICAS_BIODATA', 'Parámetro POLITICAS_BIODATA no configurado')"></div>
          </a-col>
          <a-col>
            <a-checkbox @change="politicsChange">
              Para continuar debes aceptar las políticas.
            </a-checkbox>
          </a-col>
        </a-row>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        isPoliticsVisible: false,
        loadingParent: false,
        biodata_politicas_desactivadas: this.$getConfigValue('BIODATA_POLITICAS_DESACTIVADAS', 'NO') === 'SI',
        roles: {
          permiso_bloque_1: this.$userIsInrol('BIODATA_BLOQUE_1'),
          permiso_bloque_2: this.$userIsInrol('BIODATA_BLOQUE_2'),
          permiso_bloque_3: this.$userIsInrol('BIODATA_BLOQUE_3'),
          permiso_bloque_4: this.$userIsInrol('BIODATA_BLOQUE_4'),
          permiso_bloque_5: this.$userIsInrol('BIODATA_BLOQUE_5'),
          permiso_bloque_6: this.$userIsInrol('BIODATA_BLOQUE_6'),
          permiso_bloque_7: this.$userIsInrol('BIODATA_BLOQUE_7'),
          permiso_bloque_8: this.$userIsInrol('BIODATA_BLOQUE_8'),
          permiso_bloque_9: this.$userIsInrol('BIODATA_BLOQUE_9'),
          permiso_bloque_10: this.$userIsInrol('BIODATA_BLOQUE_10'),
          permiso_bloque_11: this.$userIsInrol('BIODATA_BLOQUE_11'),
          permiso_bloque_12: this.$userIsInrol('BIODATA_BLOQUE_12'),
          permiso_bloque_13: this.$userIsInrol('BIODATA_BLOQUE_13'),
          permiso_bloque_14: this.$userIsInrol('BIODATA_BLOQUE_14')
        },
        politicState: true,
        personaSeleccioanda: '',
        loading: false,
        loadingPolitics: false,
        menuActivo: '',
        menu: {
          datosPersonales: 'DATOSPERSONALES',
          otrosdatosPersonales: 'OTROSDATOSPERSONALES',
          carguedocumentacion: 'CARGUEDOCUMENTACION',
          datosfamiliares: 'DATOSFAMILIARES',
          otrosdatosfamiliares: 'OTROSDATOSFAMILIARES',
          informacionacademica: 'INFORMACIONACADEMICA',
          referencias: 'REFERENCIAS',
          otrainformacionlaboral: 'OTRAINFORMACIONLABORAL',
          informacionbancaria: 'INFORMACIONBANCARIA',
          idiomaotrosestudios: 'IDIOMAOTROSESTUDIOS',
          informacionlaboral: 'INFORMACIONLABORAL',
          forularios: 'FORMULARIOS',
          cliente: 'CLIENTE',
          finalizacioningresodatos: 'FINALIZACIONINGRESODATOS'
        },
        form: this.$form.createForm(this, {
          name: 'frmBiotada'
        }),
        persona: {}
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.personaSeleccioanda = this.$store.state.userInfo.id_person
      this.menuActivo = this.menu.datosPersonales
    },
    methods: {
      statePolitics () {
        if (this.biodata_politicas_desactivadas || this.persona.acepta_politicas || this.puedeCrear === true ||
          JsUtils.isEmpty(this.$store.state.userInfo.id_person)) {
          this.isPoliticsVisible = false
        } else if (!this.persona.acepta_politicas && !this.$userIsInrol('Management')) {
          this.isPoliticsVisible = true
        }
      },
      changeStatePolitics () {
        this.loadingPolitics = true
        this.httpClient.getInstance().post('biodata/actualizar_politicas_empresa')
          .then(() => {
            this.isPoliticsVisible = false
            Mensajes.success('Correcto', 'Se registró correctamente.')
          })
          .catch(error => {
            let result = 'No fue posible registrar. Contacte al administrador.'
            if (!JsUtils.isEmpty(error.response)) {
              result = JsUtils.isEmpty(error.response.data) ? 'No fue posible registrar.' : error.response.data.message
            }
            Mensajes.error('Error', result)
          })
          .then(() => {
            this.loadingPolitics = false
          })
      },
      politicsChange (action) {
        if (action.target.checked === false) {
          this.politicState = true
        } else {
          this.politicState = false
        }
      },
      loadProfileData () {
        this.loading = true
        this.loadingParent = true

        this.httpClient.getInstance().get('picture_service/render/profile', {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            this.profileSrc = window.URL.createObjectURL(blob)
          })

        this.httpClient.getInstance().get('biodata/consultarDatosPersonales/' + this.personaSeleccioanda)
          .then(response => {
            this.personaCreada({
              ...response.data,
              nombre: response.data.name,
              identificacion: response.data.id_person
            })
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posble cargar los datos del resumen')
          })
          .then(() => {
            this.loading = false
            this.loadingParent = false
          })
      },
      personaCreada (person) {
        this.form.setFieldsValue({
          'identificacion': person.id_person
        })
        this.$refs.persona && this.$refs.persona.handleSearch(person.id_person)
        this.personaCambiada(person.id_person)
        this.persona = person
        this.statePolitics()
      },
      personaCambiada (identificacion) {
        this.personaSeleccioanda = identificacion
      },
      seleccionarMenu (e) {
        this.menuActivo = e.key
      }
    },
    watch: {
      personaSeleccioanda () {
        this.loadProfileData()
      }
    },
    computed: {
      puedeCrear () {
        return this.$userIsInrol('Biodata')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Biodata/Biodata.vue